export const defaultGrid = {
  headerDef: [],
  rowDef: [],
  data: [],
};

export const defaultRow = { installationId: null };

export const updateGridOption = (grid, option) => {
  let newGrid = { ...grid };
  const data = [...newGrid.data];

  data.forEach((row, rowIndex) => {
    row.cellData.forEach((cell, cellIndex) => {
      if (cell.data.code === option.code) {
        let cellData = { ...data[rowIndex].cellData };
        cellData[cellIndex].data = { ...option };
        data[rowIndex].cellData = cellData;
      }
    });
  });

  return { ...newGrid, data: { ...data } };
};

// Dummy grid for internal testing purpose only
export const dummyGrid = {
  data: [
    {
      sessionId: 2800152,
      sessionGuid: "a0fdf435-ae88-f011-96c7-005056ac92e1",
      cellData: [
        {
          type: "control",
          data: {
            text: "",
            id: 0,
            type: 10,
            data: null,
            defaultText: "FALSE",
            defaultList: null,
            defaultDate: "0001-01-01T00:00:00",
            isEditable: true,
            isRequired: true,
            code: "CHECK",
            isHidden: false,
            doRefresh: false,
            regex: null,
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            maxLength: 0,
            setFocus: false,
            isValid: true,
            checkDenom: 0,
            entryPattern: null,
            inverted: false,
            flash: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Position",
            displayValue: "2",
            actualValue: "2",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "MIN",
            displayValue: "9003",
            actualValue: "9003",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Date & Time",
            displayValue: "03/09 11:44",
            actualValue: "03/09 11:44",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Session Duration",
            displayValue: "00:33",
            actualValue: "00:33",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Net Income",
            displayValue: "£53.50",
            actualValue: "53.50",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Bet",
            displayValue: "£0.00",
            actualValue: "0.00",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Win",
            displayValue: "£0.00",
            actualValue: "0.00",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Triggered Alert",
            displayValue: "True",
            actualValue: "True",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
      ],
    },
    {
      sessionId: 2800153,
      sessionGuid: "b0fdf435-ae88-f011-96c7-005056ac92e1",
      cellData: [
        {
          type: "control",
          data: {
            text: "",
            id: 0,
            type: 10,
            data: null,
            defaultText: "FALSE",
            defaultList: null,
            defaultDate: "0001-01-01T00:00:00",
            isEditable: true,
            isRequired: true,
            code: "CHECK",
            isHidden: false,
            doRefresh: false,
            regex: null,
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            maxLength: 0,
            setFocus: false,
            isValid: true,
            checkDenom: 0,
            entryPattern: null,
            inverted: false,
            flash: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Position",
            displayValue: "8",
            actualValue: "8",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "MIN",
            displayValue: "56789",
            actualValue: "56789",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Date & Time",
            displayValue: "03/09 11:44",
            actualValue: "03/09 11:44",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Session Duration",
            displayValue: "00:33",
            actualValue: "00:33",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Net Income",
            displayValue: "£53.50",
            actualValue: "53.50",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Bet",
            displayValue: "£0.00",
            actualValue: "0.00",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Win",
            displayValue: "£0.00",
            actualValue: "0.00",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Triggered Alert",
            displayValue: "True",
            actualValue: "True",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
      ],
    },
    {
      sessionId: 2800154,
      sessionGuid: "c0fdf435-ae88-f011-96c7-005056ac92e1",
      cellData: [
        {
          type: "control",
          data: {
            text: "",
            id: 0,
            type: 10,
            data: null,
            defaultText: "FALSE",
            defaultList: null,
            defaultDate: "0001-01-01T00:00:00",
            isEditable: true,
            isRequired: true,
            code: "CHECK",
            isHidden: false,
            doRefresh: false,
            regex: null,
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            maxLength: 0,
            setFocus: false,
            isValid: true,
            checkDenom: 0,
            entryPattern: null,
            inverted: false,
            flash: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Position",
            displayValue: "6",
            actualValue: "6",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "MIN",
            displayValue: "54321",
            actualValue: "54321",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Date & Time",
            displayValue: "03/09 11:44",
            actualValue: "03/09 11:44",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Session Duration",
            displayValue: "00:33",
            actualValue: "00:33",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Net Income",
            displayValue: "£53.50",
            actualValue: "53.50",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Bet",
            displayValue: "£0.00",
            actualValue: "0.00",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Win",
            displayValue: "£0.00",
            actualValue: "0.00",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
        {
          type: "cell",
          data: {
            name: "Triggered Alert",
            displayValue: "True",
            actualValue: "True",
            backColour: {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              isKnownColor: false,
              isEmpty: true,
              isNamedColor: false,
              isSystemColor: false,
              name: "0",
            },
            foreColour: {
              r: 255,
              g: 0,
              b: 0,
              a: 255,
              isKnownColor: true,
              isEmpty: false,
              isNamedColor: true,
              isSystemColor: false,
              name: "Red",
            },
            hide: false,
            isHeader: false,
            isClickable: false,
          },
        },
      ],
    },
  ],
  headerDef: [
    {
      text: "",
      alignment: 1,
    },
    {
      text: "Position",
      alignment: 1,
    },
    {
      text: "MIN",
      alignment: 1,
    },
    {
      text: "Date & Time",
      alignment: 0,
    },
    {
      text: "Session Duration",
      alignment: 1,
    },
    {
      text: "Net Income",
      alignment: 1,
    },
    {
      text: "Bet",
      alignment: 1,
    },
    {
      text: "Win",
      alignment: 1,
    },
    {
      text: "Triggered Alert",
      alignment: 1,
    },
  ],
  rowDef: [
    {
      alignment: 1,
    },
    {
      alignment: 1,
    },
    {
      alignment: 0,
    },
    {
      alignment: 0,
    },
    {
      alignment: 1,
    },
    {
      alignment: 2,
    },
    {
      alignment: 2,
    },
    {
      alignment: 2,
    },
    {
      alignment: 1,
    },
  ],
};
